/**
 * @file Chatbot URL generators
 */

import {
  ROUTE__CHATBOT_LULU,
  ROUTE__MORE,
} from '../../constants/routing/routes';
import { Hotel } from '../../generated/graphql';

/**
 * Get URL for chatbot Lulu page
 *
 * @param hotelId The hotel ID to generate the URL for
 * @returns       URL for the chatbot Lulu page
 */
export const getChatbotLuluUrl = (hotelId: Hotel['id']) => {
  return `/${hotelId}/${ROUTE__MORE}/${ROUTE__CHATBOT_LULU}`;
};
